<template>
  <div>
    <b-row>
      <!-- frame Vehicle Kilometer Travel -->
      <b-col>
        <b-row class="mb-1">
          <!-- Peak Hour Factor -->
          <b-col cols="6">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 358 181"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5 180L1 160.598V11.014H318.693L331.5 1H357V11.014V160.598L341.5 180H16.5Z"
                stroke="#00B058"
              />
              <path
                d="M325 0H329L318 8H314L325 0Z"
                fill="#00B058"
              />
              <path
                d="M318 0H322L311 8H307L318 0Z"
                fill="#00B058"
              />
              <path
                d="M311 0H315L304 8H300L311 0Z"
                fill="#00B058"
              />
              <path
                d="M304 0H308L297 8H293L304 0Z"
                fill="#00B058"
              />
              <path
                d="M297 0H301L290 8H286L297 0Z"
                fill="#00B058"
              />
              <path
                d="M290 0H294L283 8H279L290 0Z"
                fill="#00B058"
              />

              <foreignObject
                x="15"
                y="15"
                width="350"
                height="150"
                color="#ffffff"
                font-size="20"
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 0C5.8318 0 0 5.8318 0 13C0 20.1682 5.8318 26 13 26C20.1682 26 26 20.1682 26 13C26 5.8318 20.1682 0 13 0ZM17.2809 19.1191L11.7 13.5382V5.2H14.3V12.4618L19.1191 17.2809L17.2809 19.1191V19.1191Z"
                    fill="url(#paint0_linear_751_16398)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_751_16398"
                      x1="13"
                      y1="0"
                      x2="13"
                      y2="26"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop
                        offset="0.458333"
                        stop-color="#F2994A"
                      />
                      <stop
                        offset="1"
                        stop-color="#CF6608"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="50"
                y="17"
                width="350"
                height="150"
                color="#ffffff"
                font-size="20"
              >
                <div>
                  <strong>Peak Hour Factor</strong>
                  <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                x="320"
                y="25"
              >
                <feather-icon
                  id="popover-phf"
                  icon="AlertCircleIcon"
                  size="24"
                  stroke="#F9A600"
                />
                <b-popover
                  target="popover-phf"
                  triggers="focus"
                  placement="left"
                >
                  <b-img
                    src="@/assets/images/formula/phf.jpeg"
                    fluid
                  />
                </b-popover>
              </foreignObject>
              <foreignObject
                x="40"
                y="65"
                width="300"
                height="150"
                color="#ffffff"
                font-size="40"
                style="text-align: left;"
              >
                <div>
                  <b> {{ PHF }} </b>
                </div>
              </foreignObject>
            </svg>
          </b-col>
          <!-- Lane Density -->
          <b-col cols="6">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 358 181"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5 180L1 160.598V11.014H318.693L331.5 1H357V11.014V160.598L341.5 180H16.5Z"
                stroke="#00B058"
              />
              <path
                d="M325 0H329L318 8H314L325 0Z"
                fill="#00B058"
              />
              <path
                d="M318 0H322L311 8H307L318 0Z"
                fill="#00B058"
              />
              <path
                d="M311 0H315L304 8H300L311 0Z"
                fill="#00B058"
              />
              <path
                d="M304 0H308L297 8H293L304 0Z"
                fill="#00B058"
              />
              <path
                d="M297 0H301L290 8H286L297 0Z"
                fill="#00B058"
              />
              <path
                d="M290 0H294L283 8H279L290 0Z"
                fill="#00B058"
              />
              <foreignObject
                x="15"
                y="15"
                width="350"
                height="150"
                color="#ffffff"
                font-size="20"
              >
                <svg
                  width="29"
                  height="30"
                  viewBox="0 0 29 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.375 29L4.875 1"
                    stroke="url(#paint0_linear_751_16415)"
                    stroke-width="2"
                  />
                  <path
                    d="M27.625 29L24.125 1"
                    stroke="url(#paint1_linear_751_16415)"
                    stroke-width="2"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.0625 1H21.5L25.875 29H16.5V28.4013V28.125H12.5V28.4013V29H3.125L7.0625 1ZM12.5 4.96053V2.75H16.5V4.96053V9.75H12.5V4.96053ZM12.5 12.375V14.0329V17.625H16.5V14.0329V12.375H12.5ZM12.5 21.9079V20.25H16.5V21.9079V25.5H12.5V21.9079Z"
                    fill="url(#paint2_linear_751_16415)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_751_16415"
                      x1="3.125"
                      y1="1"
                      x2="3.125"
                      y2="29"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#E7E7E7" />
                      <stop
                        offset="0.515625"
                        stop-color="#A3A3A3"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_751_16415"
                      x1="25.875"
                      y1="1"
                      x2="25.875"
                      y2="29"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#E7E7E7" />
                      <stop
                        offset="0.614583"
                        stop-color="#A3A3A3"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_751_16415"
                      x1="14.5"
                      y1="1"
                      x2="14.5"
                      y2="29"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#E7E7E7" />
                      <stop
                        offset="0.666667"
                        stop-color="#A3A3A3"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="50"
                y="17"
                width="350"
                height="150"
                color="#ffffff"
                font-size="20"
              >
                <div>
                  <strong>Lane Density</strong>
                  <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                x="320"
                y="25"
              >
                <feather-icon
                  id="density"
                  icon="AlertCircleIcon"
                  size="24"
                  stroke="#F9A600"
                />
                <b-popover
                  target="density"
                  triggers="focus"
                >
                  <b-img
                    src="@/assets/images/formula/lane.jpeg"
                    width="250"
                  />
                </b-popover>
              </foreignObject>
              <foreignObject
                x="50"
                y="65"
                width="300"
                height="150"
                color="#ffffff"
                font-size="40"
              >
                <div>
                  <b> {{ DensityLane_Total_Avg }} </b>
                </div>
              </foreignObject>
            </svg>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <!-- Free Flow Speed -->
          <b-col cols="6">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 358 181"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5 180L1 160.598V11.014H318.693L331.5 1H357V11.014V160.598L341.5 180H16.5Z"
                stroke="#00B058"
              />
              <path
                d="M325 0H329L318 8H314L325 0Z"
                fill="#00B058"
              />
              <path
                d="M318 0H322L311 8H307L318 0Z"
                fill="#00B058"
              />
              <path
                d="M311 0H315L304 8H300L311 0Z"
                fill="#00B058"
              />
              <path
                d="M304 0H308L297 8H293L304 0Z"
                fill="#00B058"
              />
              <path
                d="M297 0H301L290 8H286L297 0Z"
                fill="#00B058"
              />
              <path
                d="M290 0H294L283 8H279L290 0Z"
                fill="#00B058"
              />
              <foreignObject
                x="15"
                y="15"
                width="350"
                height="150"
                color="#ffffff"
                font-size="20"
              >
                <svg
                  width="33"
                  height="32"
                  viewBox="0 0 33 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="10.427"
                    y="23.7705"
                    width="11.5617"
                    height="2.07644"
                    rx="1"
                    fill="url(#paint0_linear_751_16440)"
                  />
                  <rect
                    x="8.5"
                    y="27.9233"
                    width="15.4156"
                    height="2.07644"
                    rx="1"
                    fill="url(#paint1_linear_751_16440)"
                  />
                  <path
                    d="M15.6433 17.9194C16.3958 17.1085 23.1374 12.7805 23.1374 12.7805C23.1374 12.7805 19.1209 20.0451 18.3684 20.856C17.6159 21.6669 16.3958 21.6669 15.6433 20.856C14.8908 20.0451 14.8908 18.7303 15.6433 17.9194Z"
                    fill="url(#paint2_linear_751_16440)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.58928 10.3665C5.18764 5.63296 9.96281 2.35451 15.5 2V6.75901C11.2214 7.14412 7.61751 9.97683 5.99411 13.9014L2.58928 10.3665ZM25.6166 11.4229C23.7188 8.82112 20.8115 7.05698 17.5 6.75899V2C22.2573 2.30458 26.4522 4.76748 29.1873 8.45715L25.6166 11.4229ZM27.0382 13.9797C27.6117 15.3943 27.9287 16.9485 27.9287 18.5796C27.9287 21.8134 26.6826 24.7451 24.6618 26.8853H30.3595C31.7209 24.442 32.5 21.6052 32.5 18.5796C32.5 15.8219 31.8528 13.2212 30.7074 10.9322L27.0382 13.9797ZM0.5 18.5796C0.5 21.6052 1.27915 24.442 2.64049 26.8853H8.33844C6.3176 24.7451 5.07153 21.8134 5.07153 18.5796C5.07153 17.7931 5.14524 17.0245 5.28586 16.2808L1.61645 12.4711C0.89593 14.3619 0.5 16.4227 0.5 18.5796Z"
                    fill="url(#paint3_linear_751_16440)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_751_16440"
                      x1="16.2079"
                      y1="23.7705"
                      x2="16.2079"
                      y2="25.8469"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFD331" />
                      <stop
                        offset="0.8125"
                        stop-color="#FFEBA2"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_751_16440"
                      x1="16.2078"
                      y1="27.9233"
                      x2="16.2078"
                      y2="29.9998"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFD331" />
                      <stop
                        offset="0.8125"
                        stop-color="#FFEBA2"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_751_16440"
                      x1="22"
                      y1="13.9078"
                      x2="13.9628"
                      y2="21.0936"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFEBA1" />
                      <stop
                        offset="0.854167"
                        stop-color="#FFD331"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_751_16440"
                      x1="16.5"
                      y1="2"
                      x2="16.5"
                      y2="26.8853"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFEBA1" />
                      <stop
                        offset="0.666667"
                        stop-color="#FFD331"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="60"
                y="17"
                width="350"
                height="150"
                color="#ffffff"
                font-size="20"
              >
                <div>
                  <strong>Free Flow Speed</strong>
                  <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                x="320"
                y="25"
              >
                <feather-icon
                  id="ffs"
                  icon="AlertCircleIcon"
                  size="24"
                  stroke="#F9A600"
                />
                <b-popover
                  target="ffs"
                  triggers="focus"
                  placement="left"
                >
                  <b-img
                    src="@/assets/images/formula/ffs.jpeg"
                    fluid
                  />
                </b-popover>
              </foreignObject>
              <foreignObject
                x="50"
                y="65"
                width="300"
                height="150"
                color="#ffffff"
                font-size="40"
              >
                <div>
                  <b> {{ FreeFlowSpeed }} </b>
                  <strong style="font-size: 20px;">กม./ชม.</strong>
                </div>
              </foreignObject>
            </svg>
          </b-col>
          <!-- Average Speed -->
          <b-col cols="6">
            <svg
              v-if="wid === '910'"
              width="100%"
              height="100%"
              viewBox="0 0 358 181"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5 180L1 160.598V11.014H318.693L331.5 1H357V11.014V160.598L341.5 180H16.5Z"
                stroke="#00B058"
              />
              <path
                d="M325 0H329L318 8H314L325 0Z"
                fill="#00B058"
              />
              <path
                d="M318 0H322L311 8H307L318 0Z"
                fill="#00B058"
              />
              <path
                d="M311 0H315L304 8H300L311 0Z"
                fill="#00B058"
              />
              <path
                d="M304 0H308L297 8H293L304 0Z"
                fill="#00B058"
              />
              <path
                d="M297 0H301L290 8H286L297 0Z"
                fill="#00B058"
              />
              <path
                d="M290 0H294L283 8H279L290 0Z"
                fill="#00B058"
              />
              <foreignObject
                width="100%"
                height="100%"
                x="10"
                y="20"
              >
                <div>
                  <b-img
                    src="@/assets/images/icons/count3.svg"
                  />
                </div>
              </foreignObject>
              <foreignObject
                x="50"
                y="17"
                width="350"
                height="150"
                color="#ffffff"
                font-size="20"
              >
                <div>
                  <strong>Speed Limit</strong>
                  <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                x="250"
                y="12"
              >
                <b-button
                  id="toggle-btn"
                  v-b-modal="'modalCarSpeed'"
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary"
                  style="font-size: 14px;"
                  title="Click to show more"
                >
                  <span
                    class="align-middle"
                    style="color: #11DF00;"
                  >
                    ดูเพิ่มเติม
                    <feather-icon
                      icon="ChevronsRightIcon"
                      size="14"
                    />
                  </span>
                </b-button>
              </foreignObject>
              <foreignObject
                x="50"
                y="50"
                width="300"
                height="150"
                color="#ffffff"
                font-size="40"
              >
                <div>
                  <strong style="font-size: 20px;">Max:</strong><b> {{ Speed_Max_TSC }} </b>
                  <strong style="font-size: 20px;">กม./ชม.</strong>
                </div>
              </foreignObject>
              <foreignObject
                x="50"
                y="110"
                width="300"
                height="150"
                color="#ffffff"
                font-size="40"
              >
                <div>
                  <strong style="font-size: 20px;"> Min:</strong><b> {{ Speed_Min_TSC }} </b>
                  <strong style="font-size: 20px;">กม./ชม.</strong>
                </div>
              </foreignObject>
            </svg>
            <svg
              v-if="wid !== '910'"
              width="100%"
              height="100%"
              viewBox="0 0 358 181"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5 180L1 160.598V11.014H318.693L331.5 1H357V11.014V160.598L341.5 180H16.5Z"
                stroke="#00B058"
              />
              <path
                d="M325 0H329L318 8H314L325 0Z"
                fill="#00B058"
              />
              <path
                d="M318 0H322L311 8H307L318 0Z"
                fill="#00B058"
              />
              <path
                d="M311 0H315L304 8H300L311 0Z"
                fill="#00B058"
              />
              <path
                d="M304 0H308L297 8H293L304 0Z"
                fill="#00B058"
              />
              <path
                d="M297 0H301L290 8H286L297 0Z"
                fill="#00B058"
              />
              <path
                d="M290 0H294L283 8H279L290 0Z"
                fill="#00B058"
              />
              <foreignObject
                width="100%"
                height="100%"
                x="10"
                y="20"
              >
                <div>
                  <b-img
                    src="@/assets/images/icons/count3.svg"
                  />
                </div>
              </foreignObject>
              <foreignObject
                x="50"
                y="17"
                width="350"
                height="150"
                color="#ffffff"
                font-size="20"
              >
                <div>
                  <strong>Max Speed</strong>
                  <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
              <foreignObject
                width="100%"
                height="100%"
                x="290"
                y="12"
              >
                <b-button
                  id="min"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="flat-warning"
                  style="font-size: 20px; text-decoration: underline;"
                >Min</b-button>
                <b-popover
                  target="min"
                  triggers="focus"
                  placement="left"
                >
                  <div>
                    <h4>Min Speed</h4>
                    <span style="font-size: 20px;"> {{ Speed_Min }} </span>
                    <span style="font-size: 20px;">กม./ชม.</span>
                  </div>
                </b-popover>
              </foreignObject>
              <foreignObject
                x="50"
                y="65"
                width="300"
                height="150"
                color="#ffffff"
                font-size="40"
              >
                <div>
                  <b> {{ Speed_Max }} </b>
                  <strong style="font-size: 20px;">กม./ชม.</strong>
                </div>
              </foreignObject>
            </svg>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <ModalCarSpeed />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BPopover, BButton,
} from 'bootstrap-vue'
import axios from '@axios'
import ModalCarSpeed from './ModalCarSpeed.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BPopover,
    BButton,
    ModalCarSpeed,
  },
  data() {
    return {
      statisticTitle: '',
      Total: '',
      Speed_Max: 0,
      Speed_Min: 0,
      Speed_Max_TSC: 0,
      Speed_Min_TSC: 0,
      PHF: 0,
      FreeFlowSpeed: 0,
      DensityLane_Total_Avg: 0,
      wid: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getFormula()
    this.getSumCount()
  },
  mounted() {
    this.wid = this.$route.query.wid
    this.interval = setInterval(() => {
      this.getFormula()
      this.getSumCount()
    }, 300000)
  },
  methods: {
    getFormula() {
      axios
        .post('/getFormulaCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.PHF = response.data[0].PHF
          this.FreeFlowSpeed = response.data[0].FreeFlowSpeed
          this.DensityLane_Total_Avg = response.data[0].DensityLane_Total_Avg
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSumCount() {
      axios
        .post('/getSumCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.Speed_Max = response.data[0].Speed_Max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Speed_Min = response.data[0].Speed_Min.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Speed_Max_TSC = response.data[0].max_speed_limit
          this.Speed_Min_TSC = response.data[0].min_speed_lmit
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
.progress1 .progress-bar{background: #579BFE;}
.progress2 .progress-bar{background: #DC48FF;}
.progress3 .progress-bar{background: #8246FE;}
.progress4 .progress-bar{background: #FE447A;}
.progress5 .progress-bar{background: #4EAF51;}
.progress6 .progress-bar{background: #FF805D;}
.progress7 .progress-bar{background: #FDFF01;}

  </style>
